import { gql } from "@apollo/client";

export default gql`
  query couponCodes($args: GetAllCouponCodesInput){
    couponCodes(args: $args){
        success
        data{
            _id
            customer
            name
            code
            status
            valueType
            value
            maxRedemptions
            timesRedeemed
            usageType
            usageLimit
            usageCount
            expiredAt
            createdAt
            updatedAt
        }
        code
        message
    }
}
`
